import { ReactNode } from 'react';
import { Link } from 'react-router';

import { Button } from '@/components/shared/Button';

import cn from './styles.module.sass';

interface IErrorPageProps {
    statusCode?: number | string;
    customStatus?: ReactNode;
    message: string;
    redirectPath?: string;
    buttonText: ReactNode;
    onClick?: VoidFunction;
}

export const ErrorPage = ({
    statusCode,
    customStatus,
    message,
    redirectPath,
    buttonText,
    onClick,
}: IErrorPageProps) => {
    return (
        <div className={cn.container}>
            <div className={cn.innerContainer}>
                {customStatus ? customStatus : <div className={cn.statusCode}>{statusCode}</div>}
                <p className={cn.message}>{message}</p>
                {redirectPath ? (
                    <Link to={redirectPath}>
                        <Button className={cn.btn} onClick={onClick}>
                            {buttonText}
                        </Button>
                    </Link>
                ) : (
                    <Button className={cn.btn} onClick={onClick}>
                        {buttonText}
                    </Button>
                )}
            </div>
        </div>
    );
};
